var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    { staticClass: "media-portal-item", class: [_vm.bemFacet] },
    [
      _c("div", { staticClass: "media-portal-item--wrap" }, [
        _vm.wasActivated
          ? _c("div", { staticClass: "media-portal-item--medium" }, [
              _c("iframe", {
                staticClass: "media-portal-item--iframe",
                attrs: { src: _vm.content.url, frameborder: "0" }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.content.description
          ? _c("figcaption", {
              staticClass: "media-portal-item--description",
              domProps: { textContent: _vm._s(_vm.content.description) }
            })
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42b99d1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42b99d1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/media-portal-item-audio/index.vue
// module id = 408
// module chunks = 5